import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'

export const BeneficiaryEmptyState = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="empty-state"
      LottiePlayer={<Lottie src="no-data" />}
      title={t('manageBeneficiaries.noBeneficiaries')}
      description={
        <span className="text-foreground-prominent text-body-regular">
          {t('manageBeneficiaries.noBeneficiariesAndCannotAdd')}
        </span>
      }
    />
  )
}
